import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Empathy from "@/components/landing/Empathy";
import Logistics from "@/components/landing/Logistics";
import About from "@/components/landing/About";
import Learn from "@/components/landing/Learn";
import Curriculum from "@/components/landing/Curriculum";
import ApplyForm from "@/components/landing/ApplyForm";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useLenis();

  return (
    <>
      <div className="noise-overlay" />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid rgba(212,175,55,0.4)",
            color: "#fff",
          },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Empathy />
        <Logistics />
        <About />
        <Learn />
        <Curriculum />
        <ApplyForm />
      </main>
      <Footer />
    </>
  );
}
